<template>
  <validator name="notificationValidator">
    <form novalidate>
      <div class="mdl-grid mdl-grid--nesting">
        <div class="mdl-cell mdl-cell--12-col mdl-shadow--2dp" style="background:white">
          <div class="mdl-card fill" style="overflow:unset">
            <div class="ga-form-title">
              <h2 class="ga-title-text">{{'newDelayed.label.options' | label}}</h2>
            </div>
            <div class="mdl-card__supporting-text fill">
              <div class="mdl-grid inner-grid">
                <div class="mdl-cell mdl-cell--4-col">
                    <label class="form-label ga-required">{{'newDelayed.label.initialSending' | label}}</label>
                  </div>
                  <div class="mdl-cell mdl-cell--8-col edit-textfield mdl-textfield mdl-js-textfield dirty-check">
                    <datepicker :time.sync="initDate" :out.sync="message['newSendingDate']" type="min" format="LLLL" :limit="limit">
                      <input v-show="false" class="mdl-textfield__input" type="text" id="initialDelayMessageDate" initial="off"
                             v-model="message['initialDelayMessageDate']" v-validate:initialDelayMessageDate="['required']">
                      <span class="validation-error mdl-textfield__error" v-if="$notificationValidator.initialdelaymessagedate.required">{{'newDelayed.validation.initialSending' | label}}</span>
                      <span class="ga-input-instruction" v-if="!$notificationValidator.initialdelaymessagedate.required">{{'newDelayed.instruction.initialDelayMessageDate' | label}}</span>
                    </datepicker>
                  </div>
              </div>
              <div class="mdl-grid inner-grid">
                <div class="mdl-cell mdl-cell--4-col">
                  <label class="form-label ga-required">{{'newDelayed.label.sendCancellationEvery' | label}}</label>
                </div>
                <div class="mdl-cell mdl-cell--4-col">
                  <mdl-select name='delay_period' :value.sync="message['delayMessagePeriod']" options="SENDING_PERIOD"
                              :preselected="getDelayMessagePeriod()"></mdl-select>
                </div>
                <div class="mdl-cell mdl-cell--4-col">
                </div>
                <div class="mdl-cell mdl-cell--4-col">
                </div>
                <div class="mdl-cell mdl-cell--4-col">
                  <span class="ga-input-instruction">{{'newDelayed.instruction.delayMessagePeriod' | label}}</span>
                </div>
              </div>
              <div class="mdl-grid inner-grid">
                <div class="mdl-cell mdl-cell--4-col">
                  <label class="form-label ga-required">{{'newDelayed.label.sendAfter' | label}}</label>
                  </div>
                <div class="mdl-cell mdl-cell--4-col">
                  <div class="edit-textfield mdl-textfield mdl-js-textfield inline">
                    <input class="mdl-textfield__input" type="number" min="2" max="{{getAppConfig('maxSendAfterDays')}}" id="sendAfter" initial="off"
                           v-validate:sendAfter="{required: true, min:2, max: getAppConfig('maxSendAfterDays')}" v-model="message['sendMessageAfter']">
                    <label class="edit-textfield mdl-textfield__label ga-required" for="sendAfter"></label>
                    <span class="validation-error mdl-textfield__error"
                          v-if="$notificationValidator.sendafter.required">{{'newDelayed.validation.sendAfter' | label}}</span>
                    <span class="validation-error mdl-textfield__error"
                          v-if="$notificationValidator.sendafter.max">{{'newDelayed.validation.sendAfter.maxDays' | label}}</span>
                    <span class="validation-error mdl-textfield__error"
                          v-if="$notificationValidator.sendafter.min && !$notificationValidator.sendafter.required">{{'newDelayed.validation.sendAfter.minDays' | label}}</span>
                    <!--<span class="ga-input-instruction" v-if="!$notificationValidator.sendafter.max">{{'newDelayed.instruction.sendAfter' | label}}</span>-->
                  </div>
                </div>
                <div class="mdl-cell mdl-cell--4-col">
                  <label class="form-label">{{'newDelayed.label.days' | label}}</label>
                </div>
                <div class="mdl-cell mdl-cell--4-col">
                </div>
                <div class="mdl-cell mdl-cell--8-col">
                  <span class="ga-input-instruction" v-if="!$notificationValidator.sendafter.max">{{'newDelayed.instruction.sendAfter' | label}}</span>
                </div>
              </div>
              <div class="mdl-grid inner-grid">
                  <div class="mdl-cell mdl-cell--4-col">
                    <label class="form-label">{{'newDelayed.label.additionalEmail' | label}}</label>
                  </div>
                  <div class="mdl-cell mdl-cell--8-col">
                    <div class="edit-textfield mdl-textfield mdl-js-textfield dirty-check fill">
                      <div class="iconized">
                        <input class="mdl-textfield__input" :type="emailInputType" id="additionalDelayEmail"
                              v-model="message['additionalDelayEmail']" v-validate:additionalDelayEmail="['email']">
                        <span class="fas" :class="{'fa-eye': isFaEye, 'fa-eye-slash': isFaEyeSlash}"  @click="toggleShowEmail">&nbsp;</span>
                      </div>
                    <span class="validation-error mdl-textfield__error"
                          v-if="$notificationValidator.additionaldelayemail.email">{{'newDelayed.validation.additionalEmail.email' | label}}</span>
                    <span class="ga-input-instruction" v-if="!$notificationValidator.additionaldelayemail.email">{{'newDelayed.instruction.additionalDelayEmail' | label}}</span>
                  </div>
                </div>

              <!--<div v-if="message.status!=='SENT'" class="mdl-card__actions">-->
                <!--<div class="card-grid mdl-grid">-->
                  <!--<div class="mdl-cell mdl-cell&#45;&#45;4-col">-->
                  <!--</div>-->
                  <!--<div class="mdl-cell mdl-cell&#45;&#45;4-col">-->
                  <!--</div>-->
                <!--</div>-->
              </div>
              <div class="mdl-grid inner-grid">
                <div class="mdl-cell mdl-cell--4-col">
                  <div class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored fill"
                  v-on:click="validate()">
                    <span>
                      {{'newDelayed.button.save' | label}}
                    </span>
                  </div>
                </div>
                <div class="mdl-cell mdl-cell--8-col">
                  <span class="form-label">{{'newDelayed.button.save.instructions' | label}}</span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </form>
  </validator>
</template>

<script>
//  var config = require('common/config')
  var getters = require('common/store/getters')
  var label = require('vue').filter('label')
  var appConfig = require('vue').filter('appConfig')
  module.exports = {
    ready: function () {
      window.componentHandler.upgradeAllRegistered()
    },
    vuex: {
      getters: getters
    },
    props: {
      model: Object,
      registration: Boolean,
      initDate: String
    },
    components: {
      'datepicker': require('c/components/Datepicker'),
      mdlSelect: require('c/components/Select')
    },
    methods: {
      validate: function () {
        var self = this
        this.$validate(true, function () {
          if (self.$notificationValidator.invalid) {
            return
          }
//          self.message.phone = self.message.phoneCode + self.message.phoneNumber
          self.$dispatch('message-valid', self.message)
        })
      },
      clearFileInput: function () {
        this.$els.file.value = ''
      },
      getLabel: function (key) {
        return label(key)
      },
      getDelayMessagePeriod: function () {
        return this.message['delayMessagePeriod'] ? this.message['delayMessagePeriod'].toString() : '1'
      },
      getAppConfig: function (key) {
        return appConfig(key)
      },
      addAttachment: function () {
        var self = this
        if (!self.uploading) {
          self.clearFileInput()
          self.$els.file.click()
        }
      },
      toggleShowEmail: function () {
        this.emailInputType = (this.isFaEye ? 'email' : 'password')
        this.isFaEye = !this.isFaEye
        this.isFaEyeSlash = !this.isFaEyeSlash
      }
    },
    data: function () {
      return {
        message: {
          initialDelayMessageDate: '',
          delayMessagePeriod: '',
          sendMessageAfter: '',
          delayMethod: '',
          additionalDelayEmail: '',
          serviceCode: '',
          phoneCode: '',
          phoneNumber: '',
          phone: ''
        },
        user: {},
        isFaEye: true,
        isFaEyeSlash: false,
        emailInputType: 'password'
      }
    },
    watch: {
      'model': {
        handler: function (model) {
          this.message = this.model
        },
        deep: true
      }
    },
    computed: {
      totalAttachmentSize: function () {
        var result = 0
        if (this.message.attachments) {
          this.message.attachments.forEach(function (attachment) {
            result += attachment.size
          })
        }
        return result
      },
      defaultTimeZone: function () {
        if (self.user) {
          return this.user.timeZone
        } else {
          var moment = require('moment-timezone')
          return moment.tz.guess()
        }
      },
      limit: function () {
        var moment = require('moment-timezone')
        var from = moment().subtract(1, 'days')
        return [{
          type: 'fromto',
          from: from
        }]
      }
    }
  }
</script>

<style scoped>
  .padding-top {
    padding-top: 20px;
  }

  .getmdl-select {
    position: absolute;
  }

</style>



// WEBPACK FOOTER //
// NotificationForm.vue?a96cf63a